import { createTheme } from '@material-ui/core';
import { v3StyleGuideTheme } from '../../../theme';
import { createMuiTheme } from '../../shared/components/MaterialUIComponents';

export const theme = createMuiTheme(v3StyleGuideTheme);

export const RELATIVE_POSITION = {
  header_SideBar: '125px'
};
